import { Box } from '@material-ui/core';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import { useEnqueteDailyStyles } from '../../../assets/styles/Report.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  answer: string | number;
};

/**
 *
 *
 *
 * @method Component
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const EnqueteAnswerResult = (props: Props) => {
  const { answer } = props;
  const classes = useEnqueteDailyStyles();

  return (
    <Box
      className={classes.answerResult}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      {[...Array(5)].map((val, index) => (
        <Box key={index}>
          <div className={classes.answerResultItem}>
            {answer === index + 1 && <CircleIcon />}
          </div>
        </Box>
      ))}
    </Box>
  );
};

export default EnqueteAnswerResult;
